import { useState } from "react";
import { toast } from "sonner";
import { favorites, history, savedKeys } from "@/lib/publicApi";
import { hasSecureStoreBridge, secretVault } from "@/lib/nativeBridge";
import { BiometricLockCard } from "@/components/BiometricLockCard";
import { PushPreferenceCard } from "@/components/PushPreferenceCard";
import { Button } from "@/components/ui/button";

export default function SaudeSettings() {
  const [keys, setKeys] = useState(savedKeys.list());
  const [fontLarge, setFontLarge] = useState(document.documentElement.style.fontSize === "18px");

  const toggleFont = () => {
    const next = !fontLarge;
    document.documentElement.style.fontSize = next ? "18px" : "";
    setFontLarge(next);
  };

  return (
    <div data-testid="saude-settings-page" className="space-y-6">
      <h1 className="font-display text-2xl font-medium tracking-tight text-ink-900">Configurações</h1>

      <BiometricLockCard productName="Erimus – Saúde Mental" />

      <PushPreferenceCard
        app="saude"
        testId="saude-push-preference"
        title="Notificações"
        description="Avisos de novos conteúdos educativos publicados pela Erimus."
      />

      <section className="er-card">
        <p className="er-label">Leitura</p>
        <p className="mt-2 text-sm text-ink-600">Aumentar o tamanho do texto do aplicativo.</p>
        <Button data-testid="settings-toggle-font" onClick={toggleFont} variant="outline" className="mt-4 h-11 rounded-full">
          {fontLarge ? "Voltar ao tamanho padrão" : "Aumentar tamanho da fonte"}
        </Button>
      </section>

      <section className="er-card">
        <p className="er-label">Dados neste dispositivo</p>
        <p className="mt-2 text-sm text-ink-600">
          Salvos: {favorites.list().length} · Histórico: {history.list().length} · Chaves guardadas: {keys.length}
        </p>
        <div className="mt-4 flex flex-wrap gap-3">
          <Button
            data-testid="settings-clear-history"
            variant="outline"
            onClick={() => {
              history.clear();
              toast.success("Histórico local apagado");
            }}
            className="h-11 rounded-full"
          >
            Limpar histórico
          </Button>
        </div>
      </section>

      <section className="er-card">
        <p className="er-label">Chaves de acesso salvas</p>
        {keys.length === 0 ? (
          <p className="mt-2 text-sm text-ink-500">Nenhuma chave guardada neste dispositivo.</p>
        ) : (
          <div className="mt-3 space-y-3">
            {keys.map((p, index) => (
              <div key={p.secret_key} data-testid={`settings-key-${index}`} className="flex items-center justify-between gap-3">
                <span className="text-sm text-ink-700">Chave •••{p.secret_key.slice(-4)}</span>
                <button
                  data-testid={`settings-key-remove-${index}`}
                  onClick={() => {
                    savedKeys.remove(p.secret_key);
                    setKeys(savedKeys.list());
                  }}
                  className="text-xs text-danger"
                >
                  Remover
                </button>
              </div>
            ))}
          </div>
        )}
        {hasSecureStoreBridge() ? (
          <Button
            data-testid="settings-vault-remove"
            variant="outline"
            onClick={async () => {
              await secretVault.remove();
              toast.success("Chave protegida por biometria removida deste aparelho");
            }}
            className="mt-4 h-11 rounded-full"
          >
            Remover chave guardada com biometria
          </Button>
        ) : null}
      </section>
    </div>
  );
}
